module.exports = __webpack_public_path__ + "static/media/noImageAvailable330.df4955a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/noImageAvailable330.png
// module id = 234
// module chunks = 1